<script lang="ts" setup>
const props = defineProps<{
  score: number
}>()

const nameMapping = new Map([
  [1, 'Ужасно'],
  [2, 'Плохо'],
  [3, 'Неплохо'],
  [4, 'Хорошо'],
  [5, 'Отлично']
])

const name = computed(() => nameMapping.get(props.score)!)
</script>

<template>
  <span class="score" :title="name">
    <SvgIcon
      v-for="x in 5"
      :key="x"
      class="star"
      :class="{ filled: x <= score, empty: x > score }"
      :name="x <= score ? 'outlined/star' : 'outlined/star-outline'"
    />
  </span>
</template>

<style lang="scss" scoped>
@use 'sass:color';

@use 'assets/css/variables';

.score {
  & > .star {
    margin-left: 4px;

    &:first-child {
      margin-left: 0;
    }

    &.filled {
      color: variables.$main-light-yellow-color;
    }

    &.empty {
      color: color.mix(variables.$main-gray-color, white, 20%);
    }
  }
}
</style>
